import PageSidebar from "./PageSidebar";

export type { PageSidebarItem } from "./PageSidebarModel";

export default PageSidebar;